// More information at confluence
// Imagery Web - Supported Entitlements

export enum SupportedEntitlements {
  MAPVIEW_SIDEBYSIDE = 'mapview.sidebyside',
  MAPVIEW_VARIABILITYVIEWSLIDER = 'mapview.variabilityviewslider',
  MAPVIEW_CUSTOMCOLOR = 'mapview.colorcustom',
  MAPVIEW_SOILDATA = 'mapview.soildata',
  MAPVIEW_MAPBIOMAS = 'mapview.mapbiomas',
  INDEX_DRYMATTER = 'mapview.drymatter',
  ANOMALY_DETECTION = 'anomaly.detection',
  SOURCE_DRONE = 'source.drone',
  INDEX_EVI = 'index.evi',
  INDEX_NDVIG = 'index.ndvig',
  INDEX_NDWI = 'index.ndwi',
  INDEX_NIR = 'index.nir',
  DOWNLOADS_IMAGES = 'downloads.images',
  ANALYTICS_TIMESERIES = 'analytics.timeseries',
  ANALYTICS_FIELDSNAPSHOT = 'analytics.fieldsnapshot',
  ANALYTICS_HISTOGRAMCSV = 'analytics.histogramcsv',
  ANALYTICS_TIMESERIESCSV = 'analytics.timeseriescsv',
  NOTES = 'notes',
  PRESCRIPTIONS = 'prescriptions',
  PRESCRIPTIONS_SEEDING = 'prescriptions.seeding',
  PRESCRIPTIONS_CROP_PROTECTION = 'prescriptions.crop_protection',
  PRESCRIPTIONS_FERTILIZER = 'prescriptions.fertilizer',
  PRODUCTIVITY_MAP = 'maps.productivity',
  CARBON_MAP = 'carbon.maps',
  YIELD_ANALYSIS = 'yield.analysis',
  DATA_LAYERS = 'data.layers',
  TRIALING_PLOTS = 'trialing.plots',
  PROTECTOR_MY_FILES = 'protector.my_files',
  VALIDATION_BLOCKS = 'allow:validation-blocks',
  WEEKLY_FIELD_INSIGHTS_REPORT = 'weekly.field.insights.report',
  US_SEVERITY_SCALE = 'us-severity-scale',
  NEMA_DIGITAL = 'nema.digital',
  DISTRIBUTOR_DASHBOARD = 'retailer.distributor_dashboard',
}
